import { makeStyles } from 'tss-react/mui';

import { commonShadow } from 'uiKit/Theme/themeUtils';

const name = 'Select';

export const useSelectStyles = makeStyles({ name })(theme => ({
  paper: {
    maxHeight: 200,
    marginTop: theme.spacing(4),

    boxShadow: commonShadow,

    '&::-webkit-scrollbar': {
      width: 3,
      height: 3,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[300],
      borderRadius: 2,
    },
  },
  root: {
    height: 32,
    minWidth: 0,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },

    '&:hover': {
      backgroundColor: theme.palette.surface.tertiary,
    },
  },
  select: {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
}));
